import React from 'react';
import cn from 'classnames';
import { PropsWithTestId } from '../../../../../../../types';
import { FileDownloadModuleType } from '../index';
import { DownloadIcon } from '../DownloadIcon';
import { Heading, Line, Paragraph } from '../../../components';
import { Button } from '../../../../Button';
import ImageTag from '../../../../../../shared/ImageTag/ImageTag';
import styles from './ThumbStyleLandscape.module.scss';
import gtmService from '../../../../../../../utils/gtm';
import { CTAClickType } from '../../../../../../../utils/gtm/types';

export type ThumbStylesLandscapeProps = Pick<
  FileDownloadModuleType,
  'ctatext' | 'title' | 'titleSize' | 'text' | 'file' | 'image'
>;

export default function ThumbStylesLandscape(
  props: PropsWithTestId<ThumbStylesLandscapeProps>,
) {
  const { ctatext, title, titleSize, text, file, image, testId } = props;

  const onClickHandler = () => {
    gtmService.ga4VideoPlay({
      cta_title: title,
      filename: file,
      description: ctatext,
    } as unknown as CTAClickType);
  };

  return (
    <div data-testid={testId} className={cn('row', styles.wrapper)}>
      <div className="col-xs-12 col-sm-12 col-lg-6">
        <div className={styles.contentWrapper}>
          <ImageTag
            className={styles.landscapeHolder}
            src={image?.path}
            alt=""
          />
          {title && (
            <div className={styles.titleWrapper}>
              <DownloadIcon className={styles.icon} />
              <Heading className={styles.title} titleSize={titleSize}>
                {title}
              </Heading>
            </div>
          )}
        </div>
      </div>
      <div className="col-xs-12 col-sm-12 col-lg-6">
        {text && (
          <>
            <Paragraph className={styles.paragraph} text={text} />
            <Line className={styles.line} />
          </>
        )}
        <Button
          data-testid="hub-module-download-link"
          onClick={onClickHandler}
          to={`/uploads/${file.filename}`}
        >
          {ctatext || 'Download'}
        </Button>
      </div>
    </div>
  );
}

ThumbStylesLandscape.defaultProps = {
  testId: 'hub-module-thumb-style-landscape',
};
